/**
 * Question World Module - QuestionTitle Component
 * Displays question number, title, and marks
 */

import React from 'react';
import { Typography } from 'antd';
import '../../styles/MCQ.css';

const { Text } = Typography;

const QuestionTitle = ({ questionIndex, title, marks }) => {
    return (
        <div className='question-title'>
            <Text
                strong
                style={{
                    fontSize: '18px',
                    display: 'inline-block',
                    fontWeight: 700
                }}
            >
                {questionIndex + 1 + '.'}

                {title}
            </Text>

            <Text type='secondary' className='question-title-marks' strong>
                Marks {marks}
            </Text>
        </div>
    );
};

export default React.memo(QuestionTitle);

